import {
  ArrowDown,
  ArrowUpRight,
  Check,
  createIcons,
  Globe2,
  Menu,
  MoveDown,
  Plus,
  Smartphone,
  X,
  Zap,
} from "lucide";
import "../styles.css";

const icons = {
  ArrowDown,
  ArrowUpRight,
  Check,
  Globe2,
  Menu,
  MoveDown,
  Plus,
  Smartphone,
  X,
  Zap,
};

const header = document.querySelector<HTMLElement>("[data-header]");
const toggle = document.querySelector<HTMLButtonElement>("[data-menu-toggle]");
const mobileNav = document.querySelector<HTMLElement>("[data-mobile-nav]");

createIcons({ icons });

window.addEventListener("scroll", () => {
  header?.classList.toggle("is-scrolled", window.scrollY > 24);
}, { passive: true });

const setMenuState = (open: boolean): void => {
  toggle?.setAttribute("aria-expanded", String(open));
  mobileNav?.classList.toggle("is-open", open);
  if (toggle) {
    toggle.innerHTML = `<i data-lucide="${open ? "x" : "menu"}" aria-hidden="true"></i><span class="sr-only">${open ? "Закрыть" : "Открыть"} меню</span>`;
    createIcons({ icons });
  }
};

toggle?.addEventListener("click", () => {
  setMenuState(toggle.getAttribute("aria-expanded") !== "true");
});

mobileNav?.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
  link.addEventListener("click", () => setMenuState(false));
});

document.querySelectorAll<HTMLDetailsElement>(".faq-list details").forEach((item) => {
  item.addEventListener("toggle", () => {
    if (item.open) createIcons({ icons });
  });
});
